// extracted by mini-css-extract-plugin
export default {"tabsList":"BuilderIoTavs_tabsList__C8ujF","tab":"BuilderIoTavs_tab__yzDKv","tabActive":"BuilderIoTavs_tabActive__ZpMRj"};